'use client'
import React, { useEffect, useState } from 'react'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form'
import { Input } from '../ui/input'
import { Button } from '../ui/button'
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import { useForm } from 'react-hook-form'
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover'
import Image from 'next/image'
import { Calendar } from '../ui/calendar'
import { cn } from '@/lib/utils'
import { format } from 'date-fns'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import axios from 'axios';
import { useRouter } from 'next/navigation';
import cal from '@/public/images/calendar-days.svg';
import chevron from '@/public/home-appointment-images/chevron-down.png'




function ForMyself({doctor, speciality, location, data, appointmentBooking, lang}) {
// console.log(speciality, 'op')  
    
    const hindiEngRegex = /^[A-Za-z\s\u0900-\u097F]+$/; // Range for both English and Hindi Unicode characters
    const formSchema = z.object({
        name : z.string().min(2, {
            message: appointmentBooking.validation.name1,
        }).max(20, {
            message: appointmentBooking.validation.name2,
        }).refine((value) => hindiEngRegex.test(value), {
            message: appointmentBooking.validation.name3,
        }),
        email: z.string()
            .nonempty({
                message: appointmentBooking.validation.email1
            })
            .email({
                message: appointmentBooking.validation.email2,
            }),

        phone: z.string().refine((value) => /^[0-9]{10}$/.test(value), {
            message:  appointmentBooking.validation.phone,
        }),


        city: z.string().nonempty({
            message: appointmentBooking.validation.city1,
        }).refine((value) => hindiEngRegex.test(value), {
            message: appointmentBooking.validation.city2,
        }),
        state: z.string().nonempty({
            message: appointmentBooking.validation.state1,
        }).refine((value) => hindiEngRegex.test(value), {
            message: appointmentBooking.validation.state2,
        }),
        pincode: z.string().nonempty({
            message: appointmentBooking.validation.pin1,
        }).refine((value) => /^\d{6}$/.test(value), {
            message: appointmentBooking.validation.pin2,
        }),

        location: z.string().nonempty({
            message: appointmentBooking.validation.loc,
        }),
        speciality: z.string().nonempty({
            message: appointmentBooking.validation.spec,
        }),
        doctor: z.string(),
        // doctor: z.string().nonempty({
        //     message: "Doctor is required.",
        // }),
        // doctor: z.string().refine(customValidator),
        date: z.date({
            message: appointmentBooking.validation.date,
        }),
    });
    //from form in home
    const [selectedDoctors,setSelectedDoctors] = useState();

    //change in onchange to store value of location and speciality
    const [locationId,setLocationId] = useState();
    const [specialityId, setspecialityId] = useState();
    
    const router = useRouter();

    async function fetchDataFromApi(url) {
        try {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          return data;
        } catch (error) {
          throw error;
        }
      }


      useEffect(() => {
        if (data.location) {
          const matchedOption = location.find(option => option.attributes.locationCity === data.location);
          if (matchedOption) {
            const apiToFetchLocation = `${process.env.NEXT_PUBLIC_API_URL}/locations/${matchedOption.id}?populate=doctors`;
      
            (async () => {
              try {
                const doctorLocation = await fetchDataFromApi(apiToFetchLocation);
                const doctorsInLocation = doctorLocation.data.attributes.doctors.data;
      
                // Find common doctors in both selected speciality and location
                const commonDoctors = doctor.filter(doctorSpeciality => {
                  return doctorsInLocation.some(doctorLocation => doctorLocation.id === doctorSpeciality.id);
                }).map(doctor => (doctor));
                setSelectedDoctors(commonDoctors);
      
              } catch (error) {
                console.error("Error:", error);
              }
            })();
          }
        }
      
        if (data.speciality) {
          const matchedOption = speciality.find(option => option.attributes.specialityName === data.speciality);
          if (matchedOption) {
            const apiToFetchDoctors = `${process.env.NEXT_PUBLIC_API_URL}/specialities/${matchedOption.id}?populate=doctors`;
      
            (async () => {
              try {
                const doctorLocation = await fetchDataFromApi(apiToFetchDoctors);
                const doctorsInLocation = doctorLocation.data.attributes.doctors.data;
                const commonDoctors = doctor.filter(doctorSpeciality => {
                  return doctorsInLocation.some(doctorLocation => doctorLocation.id === doctorSpeciality.id);
                }).map(doctor => (doctor));
                setSelectedDoctors(commonDoctors);
      
              } catch (error) {
                console.error("Error:", error);
              }
            })();
          }
        }
      
        if (data.speciality && data.location) {
          const matchedSpecialityOption = speciality.find(option => option.attributes.specialityName === data.speciality);
          const matchedLocationOption = location.find(option => option.attributes.locationCity === data.location);
      
          if (matchedSpecialityOption && matchedLocationOption) {
            const apiToFetchDoctors = `${process.env.NEXT_PUBLIC_API_URL}/specialities/${matchedSpecialityOption.id}?populate=doctors`;
            const apiToFetchLocation = `${process.env.NEXT_PUBLIC_API_URL}/locations/${matchedLocationOption.id}?populate=doctors`;
      
            (async () => {
              try {
                const doctorSpeciality = await fetchDataFromApi(apiToFetchDoctors);
                const doctorLocation = await fetchDataFromApi(apiToFetchLocation);
      
                const doctorsInSpeciality = doctorSpeciality.data.attributes.doctors.data;
                const doctorsInLocation = doctorLocation.data.attributes.doctors.data;
      
                // Find common doctors in both selected speciality and location
                const commonDoctors = doctorsInSpeciality.filter(doctorSpeciality => {
                  return doctorsInLocation.some(doctorLocation => doctorLocation.id === doctorSpeciality.id);
                }).map(doctor => (doctor));
      
                setSelectedDoctors(commonDoctors);
              } catch (error) {
                console.error("Error:", error);
              }
            })();
          }
        }
      }, [data, location, speciality]);
      
      

    
    let formSchemaBase;

    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            name: "",
            email: "",
            phone: "",
            city: "",
            state: "",
            pincode: "",
            location: data.location ? data.location:"",
            speciality: data.speciality?data.speciality:"",
            doctor: data.doctor?data.doctor:"",
            date:null
        },
    });


  const today = new Date();
    today.setHours(0, 0, 0, 0);



    const onMyselfFormSubmit = async (data) => {
        console.log(data,'submitted');
        const inputDate = new Date(data.date);
        const utcDate = new Date(inputDate.getTime() - (inputDate.getTimezoneOffset() * 60000));
        const convertedDate = utcDate.toISOString();

        // console.log(convertedDate);

        try {

            const apiUrl = `${process.env.NEXT_PUBLIC_API_URL}/appointments?locale=${lang}`; // Strapi API endpoint
           

            const patientsData = {
                patientName: data.name,
                patientEmail: data.email,
                patientPhone: data.phone,
                patientCity: data.city,
                patientState: data.state,
                patientPincode: data.pincode,
                selfAppointment:true,
                appointmentDateSelected: convertedDate,
                locationSelected: data.location,
                doctorSelected: data.doctor,
                specialitySelected: data.speciality,
                schedulerName: "itsMe",
                source:"Website",
                formName:"Book an Appointment Form",
            };
            // Strapi API endpoint
            try {
                const response = await axios.post(apiUrl, { data: patientsData }, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.status === 200) {
                    const responseData = response.data;
                    // console.log(responseData);
                    // alert('Strapi Success:itsMeDesktop'+ responseData);
                } else {
                    console.error('Failed to submit form');
                }
            } catch (error) {
                console.error('Error:', error);
            }


            // Clear the form after submission
            form.reset();
            // router.push('/book/thank-you')
            if (lang) {
                router.push(`/${lang}/book/thank-you`);
              } else {
                router.push('/book/thank-you');
              }
        } catch (error) {
            console.error('Error:', error);
        }
    };





    return (
        <>
            <Form {...form}>
                <form onSubmit={form.handleSubmit(onMyselfFormSubmit)} >
                    <div className='grid xl:grid-cols-3 lg:grid-cols-2 xl:gap-5 lg:gap-x-4'>
                        <div className='grid md:grid-cols-2 gap-5 col-span-2'>
                            <div className=''>
                                <FormField
                                    control={form.control}
                                    name="name"
                                    render={({ field }) => (
                                        <FormItem className='relative box-border space-y-0 mb-5'>
                                            <FormLabel className='text-primaryWhite p-text'>{appointmentBooking.name}*</FormLabel>
                                            <FormControl className='bg-blue-50'>
                                                <Input  {...field} className='focus-visible:ring-offset-0 text-primaryGreyText' type='text' />
                                            </FormControl>
                                            <FormMessage className="absolute left-1 -bottom-5" />
                                        </FormItem>
                                    )}
                                />
                                <FormField
                                    control={form.control}
                                    name="email"
                                    render={({ field }) => (
                                        <FormItem className='relative box-border space-y-0 mb-5'>
                                            <FormLabel className='text-primaryWhite p-text'>{appointmentBooking.mail}*</FormLabel>
                                            <FormControl className='bg-blue-50'>
                                                <Input  {...field} className='focus-visible:ring-offset-0 text-primaryGreyText' type='email' />
                                            </FormControl>
                                            <FormMessage className="absolute left-1 -bottom-5" />
                                        </FormItem>
                                    )}
                                />
                                <FormField
                                    control={form.control}
                                    name="phone"
                                    render={({ field }) => (
                                        <FormItem className='relative box-border space-y-0 mb-5'>
                                            <FormLabel className='text-primaryWhite p-text'>{appointmentBooking.phone}*</FormLabel>
                                            <FormControl className='bg-blue-50'>
                                                <Input  {...field} className='focus-visible:ring-offset-0 text-primaryGreyText' />
                                            </FormControl>

                                            <FormMessage className="absolute left-1 -bottom-5" />
                                        </FormItem>
                                    )}
                                />
                            </div>
                            <div>
                                <FormField
                                    control={form.control}
                                    name="city"
                                    render={({ field }) => (
                                        <FormItem className='relative box-border space-y-0 mb-5'>
                                            <FormLabel className='text-primaryWhite p-text'>{appointmentBooking.city}*</FormLabel>
                                            <FormControl className='bg-blue-50'>
                                                <Input  {...field} className=' focus-visible:ring-offset-0 text-primaryGreyText' type='text' />
                                            </FormControl>

                                            <FormMessage className="absolute left-1 -bottom-5" />
                                        </FormItem>
                                    )}
                                />
                                <FormField
                                    control={form.control}
                                    name="state"
                                    render={({ field }) => (
                                        <FormItem className='relative box-border space-y-0 mb-5'>
                                            <FormLabel className='text-primaryWhite p-text'>{appointmentBooking.state}*</FormLabel>
                                            <FormControl className='bg-blue-50'>
                                                <Input  {...field} className=' focus-visible:ring-offset-0 text-primaryGreyText' />
                                            </FormControl>
                                            <FormMessage className="absolute left-1 -bottom-5" />
                                        </FormItem>
                                    )}
                                />
                                <FormField
                                    control={form.control}
                                    name="pincode"
                                    render={({ field }) => (
                                        <FormItem className='relative box-border space-y-0 mb-5'>
                                            <FormLabel className='text-primaryWhite p-text'>{appointmentBooking.code}*</FormLabel>
                                            <FormControl className='bg-blue-50'>
                                                <Input  {...field} className=' focus-visible:ring-offset-0 text-primaryGreyText' />
                                            </FormControl>

                                            <FormMessage className="absolute left-1 -bottom-5" />
                                        </FormItem>
                                    )}
                                />
                            </div>
                        </div>
                        <div className='grid grid-cols-1 xl:grid-cols-1 md:grid-cols-2 xl:col-span-1 md:col-span-2 col-span-1 gap-x-5'>
                            <FormField
                                control={form.control}
                                name="location"
                                render={({ field }) => (
                                    <FormItem className='relative box-border space-y-0 mb-5'>
                                        <FormLabel className='text-primaryWhite p-text'>{appointmentBooking.loc}</FormLabel>
                                        <Select
                                                onValueChange={(newValue) => {
                                                    field.onChange(newValue); 
                                                    // Perform other operations as needed
                                                    const matchedOption = location.find(option => option.attributes.locationCity === newValue);
                                                   setLocationId(matchedOption.id);
                                                   const apiToFetchLocation = `${process.env.NEXT_PUBLIC_API_URL}/locations/${matchedOption.id}?populate=doctors`;

                                                   (async () => {
                                                       try {
                                                         const doctorLocation = await fetchDataFromApi(apiToFetchLocation);
                                                         const doctorsInLocation = doctorLocation.data.attributes.doctors.data;
                                   
                                                         // Find common doctors in both selected speciality and location
                                                         const commonDoctors = doctor.filter(doctorSpeciality => {
                                                           return doctorsInLocation.some(doctorLocation => doctorLocation.id === doctorSpeciality.id);
                                                         }).map(doctor => (doctor));
                                                        setSelectedDoctors(commonDoctors);
                                   
                                                       } catch (error) {
                                                         console.error("Error:", error);
                                                       }
                                                     })();
                                                     if(specialityId){
                                                        const apiToFetchDoctors = `${process.env.NEXT_PUBLIC_API_URL}/specialities/${specialityId}?populate=doctors`;
                                                        const apiToFetchLocation = `${process.env.NEXT_PUBLIC_API_URL}/locations/${matchedOption.id}?populate=doctors`;
                                                        (async () => {
                                                            try {
                                                              const doctorSpeciality = await fetchDataFromApi(apiToFetchDoctors);
                                                              const doctorsInSpeciality = doctorSpeciality.data.attributes.doctors.data;
                                                              const doctorLocation = await fetchDataFromApi(apiToFetchLocation);
                                                              const doctorsInLocation = doctorLocation.data.attributes.doctors.data;
                                                              // Find common doctors in both selected speciality and location
                                                              const commonDoctors = doctorsInSpeciality.filter(doctorSpeciality => {
                                                                return doctorsInLocation.some(doctorLocation => doctorLocation.id === doctorSpeciality.id);
                                                              }).map(doctor => (doctor));
                                                            //   console.log(commonDoctors);
                                                            setSelectedDoctors(commonDoctors);
                                                            } catch (error) {
                                                              console.error("Error:", error);
                                                            }
                                                          })();

                                                     }
                                                }}
                                                defaultValue={data.location}
                                                >  
                                            <FormControl className='focus-visible:ring-offset-0 bg-blue-50 w-full h-10 px-3'>
                                                <SelectTrigger className='text-primaryGreyText'>
                                                    <SelectValue placeholder={appointmentBooking.loc} />
                                                </SelectTrigger>
                                            </FormControl>
                                            <SelectContent className=' h-40'>
                                                {location?.map((e, i) => (<SelectItem key={i} value={e.attributes.locationCity}>{e.attributes.locationCity}</SelectItem>))}
                                            </SelectContent>
                                        </Select>
                                        <FormMessage className="absolute left-1 -bottom-5" />
                                    </FormItem>
                                )}
                            />
                            <FormField
                                control={form.control}
                                name="speciality"
                                render={({ field }) => (
                                    <FormItem className='relative box-border space-y-0 mb-5'>
                                        <FormLabel className='text-primaryWhite p-text'>{appointmentBooking.spec}</FormLabel>
                                        <Select onValueChange={(newValue)=>{ 
                                            field.onChange(newValue)
                                            //to perform our operations
                                            const matchedOption = speciality.find(option => option.attributes.specialityName === newValue);
                                            setspecialityId(matchedOption.id)
                                            // console.log(matchedOption.id);
                                            const apiToFetchDoctors = `${process.env.NEXT_PUBLIC_API_URL}/specialities/${matchedOption.id}?populate=doctors`;

                                            (async () => {
                                                try {
                                                  const doctorLocation = await fetchDataFromApi(apiToFetchDoctors);
                                                  const doctorsInLocation = doctorLocation.data.attributes.doctors.data;
                                                  const commonDoctors = doctor.filter(doctorSpeciality => {
                                                    return doctorsInLocation.some(doctorLocation => doctorLocation.id === doctorSpeciality.id);
                                                  }).map(doctor => (doctor));
                                                 setSelectedDoctors(commonDoctors);
                                
                                                } catch (error) {
                                                  console.error("Error:", error);
                                                }
                                              })();
                                              if(locationId){
                                                const apiToFetchDoctors = `${process.env.NEXT_PUBLIC_API_URL}/specialities/${matchedOption.id}?populate=doctors`;
                                                const apiToFetchLocation = `${process.env.NEXT_PUBLIC_API_URL}/locations/${locationId}?populate=doctors`;
                                                (async () => {
                                                    try {
                                                      const doctorSpeciality = await fetchDataFromApi(apiToFetchDoctors);
                                                      const doctorsInSpeciality = doctorSpeciality.data.attributes.doctors.data;
                                                      const doctorLocation = await fetchDataFromApi(apiToFetchLocation);
                                                      const doctorsInLocation = doctorLocation.data.attributes.doctors.data;
                                                      // Find common doctors in both selected speciality and location
                                                      const commonDoctors = doctorsInSpeciality.filter(doctorSpeciality => {
                                                        return doctorsInLocation.some(doctorLocation => doctorLocation.id === doctorSpeciality.id);
                                                      }).map(doctor => (doctor));
                                                    //   console.log(commonDoctors);
                                                    setSelectedDoctors(commonDoctors);
                                                    } catch (error) {
                                                      console.error("Error:", error);
                                                    }
                                                  })();
                                              }

                                         }} defaultValue={data.speciality} >
                                            <FormControl className='focus-visible:ring-offset-0 bg-blue-50 w-full h-10 px-3'>
                                                <SelectTrigger className='text-primaryGreyText'>
                                                    <SelectValue placeholder={appointmentBooking.spec} />
                                                </SelectTrigger>
                                            </FormControl>
                                            <SelectContent className=' h-40 overflow-scroll' >
                                                {speciality?.map((e, i) => (<SelectItem  key={i} value={e.attributes.specialityName}>{e.attributes.specialityName}</SelectItem>))}
                                            </SelectContent>
                                        </Select>
                                        <FormMessage className="absolute left-1 -bottom-5" />
                                    </FormItem>
                                )}
                            />
                            <FormField
                                control={form.control}
                                name="doctor"
                                render={({ field }) => (
                                    <FormItem className='relative box-border space-y-0 mb-5'>
                                        <FormLabel className='text-primaryWhite p-text'>{appointmentBooking.doc}</FormLabel>
                                        <Select onValueChange={field.onChange} defaultValue={data.doctor}>
                                            <FormControl className='focus-visible:ring-offset-0 bg-blue-50 w-full h-10 px-3'>
                                                <SelectTrigger className='text-primaryGreyText'>
                                                    <SelectValue placeholder={appointmentBooking.doc} />
                                                </SelectTrigger>
                                            </FormControl>
                                            <SelectContent className=' h-40 overflow-scroll'>
                                            {selectedDoctors
                                                        ? selectedDoctors.map((e, i) => (
                                                            <SelectItem key={i} value={e.attributes.doctorName}>
                                                            {e.attributes.doctorName}
                                                            </SelectItem>
                                                        ))
                                                        : doctor.map((e, i) => (
                                                            <SelectItem key={i} value={e.attributes.doctorName}>
                                                            {e.attributes.doctorName}
                                                            </SelectItem>
                                                        ))}            
                                            </SelectContent>
                                        </Select>
                                        <FormMessage className="absolute left-1 -bottom-5" />
                                    </FormItem>
                                )}
                            />
                            <FormField
                                control={form.control}
                                name="date"
                                render={({ field }) => (
                                    <FormItem className="flex flex-col relative box-border space-y-0 mb-5">
                                        <FormLabel className=' text-primaryWhite p-text pb-1'>{appointmentBooking.date}</FormLabel>
                                        <Popover >
                                            <PopoverTrigger asChild>
                                                <FormControl className='focus-visible:ring-offset-0 bg-blue-50 hover:bg-bg-formbg hover:text-none text-primaryBlack'>
                                                    <Button
                                                        variant={"outline"}
                                                        className={cn(
                                                            "text-left font-normal",
                                                            !field.value && "text-muted-foreground"
                                                        )}
                                                    >
                                                        {field.value ? (
                                                            format(field.value, "PPP")
                                                        ) : (
                                                                <span className='text-primaryGreyText'>MM/DD/YY</span>
                                                        )}
                                                        <Image src={cal} width={22} height={22} className="ml-auto h-4 w-4 opacity-60" alt='calender' />
                                                        <Image src={chevron} alt='arrow' height={16} width={16} className='text-primaryBlack opacity-40' />

                                                    </Button>
                                                </FormControl>
                                            </PopoverTrigger>
                                            <PopoverContent className="w-auto p-0" align="start">
                                                <Calendar
                                                    mode="single"
                                                    selected={field.value}
                                                    onSelect={field.onChange}
                                                    disabled={(date) => date < today} //to disable the previous dates and enable the future date
                                                    initialFocus
                                                    
                                                />
                                            </PopoverContent>
                                        </Popover>
                                        <FormMessage className="absolute left-1 -bottom-5" />
                                    </FormItem>
                                )}
                            />


                        </div>
                    </div>

                    <div className="hidden sm:block relative text-end mt-6">
                        <Button className="bg-primaryWhite text-primaryBlue border-solid border rounded-3xl border-primaryBlue px-8 py-3.5 text-center hover:bg-buttonbg hover:text-primaryWhite hover:border-primaryWhite uppercase myself-submit">{appointmentBooking.button}</Button>
                       
                    </div>
                </form>
            </Form>
        </>
    )
}

export default ForMyself
